import { writable } from 'svelte/store';
export const winner = writable(false);
export const gameStart = writable(false);
export const goToMainScreen = writable(false);
export const gameState = writable('splash');
export const currentLevel = writable(1);
